import { render, staticRenderFns } from "./carousel-speed.vue?vue&type=template&id=e0b05e04&"
import script from "./carousel-speed.vue?vue&type=script&lang=js&"
export * from "./carousel-speed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports